/**
 * Known banner IDs.
 *
 * @todo Add AddToHomeScreen when it's supported.
 */
export var KnownBannerId;
(function (KnownBannerId) {
    KnownBannerId["Announcement"] = "Announcement";
    KnownBannerId["HasNoLicense"] = "HasNoLicense";
    KnownBannerId["InvalidUser"] = "InvalidUser";
    KnownBannerId["SessionExpired"] = "SessionExpired";
    KnownBannerId["StillDontSeeAnyApps"] = "StillDontSeeAnyApps";
})(KnownBannerId || (KnownBannerId = {}));
//# sourceMappingURL=knownBannerId.js.map